import de from './de.json'
import en from './en.json'

const datasetsLocales = { en, de }

export default datasetsLocales
